
export enum Language {
  EN = 'en',
  IT = 'it',
  DE = 'de'
}

export enum FocusState {
  OFF = 'Off',
  FOCUS_10 = 'Focus 10',
  FOCUS_12 = 'Focus 12',
  FOCUS_15 = 'Focus 15',
  FOCUS_21 = 'Focus 21',
  OBE = 'OBE Protocol',
  CUSTOM = 'Custom Signal'
}

export interface StateConfig {
  id: FocusState;
  name: string;
  description: string;
  brainwaveType: string;
  baseFreq: number;
  binauralFreq: number;
  isLocked: boolean;
  color: string;
  resonance?: number;
  durationSeconds: number;
  durationLabel: string;
}

export interface Worry {
  id: string;
  text: string;
  x: number;
  y: number;
}
